<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="hiveRemovalForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                hiveRemovalForm: () => import('../forms/HiveRemovalForm'),
                headers: [
                    { text: 'On', value: 'on', format: this.formatDate },
                    { text: 'Inspection', value: 'inspectionId', table: 'inspections', form: () => import('../forms/InspectionForm') },
                    { text: 'Removal Method', value: 'removalMethod', format: this.formatEnum },
                    { text: 'Number Of Hives', value: 'numberOfHives' },
                    { text: 'Proof Of Mitigation File', value: 'proofOfMitigationFileId', table: 'files', form: () => import('../forms/FileForm') },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    inspections: [],
                    files: [],
                    items: []
                },
                sorting: [
                    { column: "on", direction: "descending" },
                    { column: "inspectionId", direction: "ascending" },
                ],
                itemsField: 'hiveRemovals',
                editPageName: 'hiveRemoval',
                apiMethod: 'HiveRemovals',
                claimName: 'HiveRemovals',
                formTitle: 'Hive Removal',
                excelTitle: 'Hive Removals',
                hasEditPage: false,
            }
        },
    };
</script>
